import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { TxScMsg, TxKwMsg } from '../_models';
import { BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TxMsgService {
    constructor(private http: HttpClient) { }

    getScMsg(id: any): Observable<TxScMsg> { //detail
      return this.http.get(`${environment.apiUrl}/tx/msg/sc/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new TxScMsg().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getScMsgAll(filter: any): Observable<ListResponse>  { //listing

      return this.http.post(`${environment.apiUrl}/tx/msg/sc/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, TxScMsg);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addScMsg(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/tx/msg/sc/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateScMsg(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/tx/msg/sc/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteScMsg(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/tx/msg/sc/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }



    getKwMsg(id: any): Observable<TxKwMsg> { //detail
      return this.http.get(`${environment.apiUrl}/tx/msg/kw/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new TxKwMsg().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getKwMsgAll(filter: any): Observable<ListResponse>  { //listing

      return this.http.post(`${environment.apiUrl}/tx/msg/kw/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, TxKwMsg);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addKwMsg(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/tx/msg/kw/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateKwMsg(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/tx/msg/kw/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteKwMsg(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/tx/msg/kw/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }
}
